import {
  ListItem,
  ListItemText,
  Select,
  Typography,
  Box,
  tokens,
} from '@cast/design-system';
import { Cloud } from '@cast/shared-types';

import {
  cloudProvidersCriterion,
  CUSTOM_EDGE_PROVIDER,
  EDGE_PROVIDER_NAME_MAP,
  SUPPORTED_EDGE_PROVIDERS,
} from '../constants';
import { EdgeLocationProvider, EnhancedEdgeLocation } from '../types';

import { CspIcon } from '@cast/shared-csp-icons-ui';

import {
  makeEnumAggregateFn,
  useFiltersDropdownAggregate,
  useSearchCriterion,
} from '@cast/shared-search-ui';

const allProviders: Record<
  Exclude<EdgeLocationProvider, Cloud.unknown>,
  Exclude<EdgeLocationProvider, Cloud.unknown>
> = {
  [Cloud.gcp]: Cloud.gcp,
  [Cloud.aws]: Cloud.aws,
  [Cloud.oracle]: Cloud.oracle,
  [Cloud.nebius]: Cloud.nebius,
  [CUSTOM_EDGE_PROVIDER]: CUSTOM_EDGE_PROVIDER,
};

export const CloudProvidersFilter = () => {
  const criterion = useSearchCriterion(cloudProvidersCriterion);

  const { aggregate, dropdownProps } = useFiltersDropdownAggregate(
    cloudProvidersCriterion.key,
    makeEnumAggregateFn<EnhancedEdgeLocation, EdgeLocationProvider>(
      allProviders,
      (edgeLocation) => edgeLocation.provider
    )
  );

  return (
    <Select
      testId="edge-locations-provider-filter"
      options={SUPPORTED_EDGE_PROVIDERS}
      inputText="Provider"
      multiple
      checkable
      sx={{ minWidth: '198px' }}
      value={criterion.value}
      onChange={(options) => {
        if (options?.length) {
          criterion.setValue?.(options);
        } else {
          criterion.clear?.();
        }
      }}
      renderOption={(provider, itemProps) => {
        return (
          <ListItem
            {...itemProps}
            startAdornment={
              provider === CUSTOM_EDGE_PROVIDER ? null : (
                <CspIcon csp={provider} size={16} />
              )
            }
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap="8px"
            >
              <ListItemText>{EDGE_PROVIDER_NAME_MAP[provider]}</ListItemText>
              <Typography
                variant="P12R"
                color={tokens.theme.fg.structural.secondary}
                width="3ch"
                textAlign="end"
              >
                {aggregate[provider]}
              </Typography>
            </Box>
          </ListItem>
        );
      }}
      {...dropdownProps}
    />
  );
};
